module.exports = __webpack_public_path__ + "static/media/truck_dark.1ca69cfa.svg";